"use strict";import{IconUserAvatar as a}from"../src/elements/IconUserAvatar.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-user-avatar",a);
//# sourceMappingURL=sp-icon-user-avatar.js.map
